<template>
    <div class="page-contact">
        <landing-header />
        
        <main>
            <section class="contact-hero py-32 bg-white">
                <div class="max-w-7xl mx-auto px-4 text-center">
                    <span class="badge-contact">Contactez-nous</span>
                    <h1 class="text-4xl md:text-6xl font-black text-gray-900 mb-6 mt-4">
                        Parlons de votre <span class="gradient-text">projet</span>
                    </h1>
                    <p class="text-xl text-gray-600 max-w-2xl mx-auto">
                        Que vous soyez un artisan indépendant ou une entreprise structurée, nos experts vous accompagnent dans la digitalisation de votre activité.
                    </p>
                </div>
            </section>
            
            <section class="pb-24">
                <div class="max-w-7xl mx-auto px-4">
                    <div class="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
                        
                        <!-- <div class="lg:col-span-4 space-y-12">
                            <div class="contact-info-block">
                                <h3 class="text-xl font-bold mb-6 text-gray-900">Nos coordonnées</h3>
                                <div class="space-y-6">
                                    <div class="info-item">
                                        <div class="info-icon"><i class="fa-solid fa-phone"></i></div>
                                        <div>
                                            <p class="text-sm text-gray-400 font-bold uppercase">Téléphone</p>
                                            <p class="text-lg font-bold text-gray-800">01 23 45 67 89</p>
                                        </div>
                                    </div>
                                    <div class="info-item">
                                        <div class="info-icon"><i class="fa-solid fa-envelope"></i></div>
                                        <div>
                                            <p class="text-sm text-gray-400 font-bold uppercase">Email</p>
                                            <p class="text-lg font-bold text-gray-800">contact@termoflow.fr</p>
                                        </div>
                                    </div>
                                    <div class="info-item">
                                        <div class="info-icon"><i class="fa-solid fa-location-dot"></i></div>
                                        <div>
                                            <p class="text-sm text-gray-400 font-bold uppercase">Siège social</p>
                                            <p class="text-lg font-bold text-gray-800">75008 Paris, France</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="demo-card-contact">
                                <h4 class="font-black text-white mb-2">Besoin d'une démo ?</h4>
                                <p class="text-orange-100 text-sm mb-4">Découvrez l'outil en direct avec l'un de nos conseillers métier.</p>
                                <button class="btn-demo-white">Réserver un créneau</button>
                            </div>
                        </div> -->
                        
                        <!-- <div class="lg:col-span-8"> -->
                        <div class="lg:col-span-8 lg:col-start-3">
                            <div class="form-container shadow-2xl">
                                <form @submit.prevent="handleSubmit" class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div class="form-group">
                                        <label>Prénom</label>
                                        <input v-model="form.prenom" type="text" placeholder="Jean" id="inp-prenom" />
                                    </div>
                                    <div class="form-group">
                                        <label>Nom</label>
                                        <input v-model="form.nom" type="text" placeholder="Dupont" id="inp-nom" />
                                    </div>
                                    <div class="form-group">
                                        <label>Email professionnel</label>
                                        <input v-model="form.email" type="email" placeholder="jean@entreprise.fr" id="inp-email" />
                                    </div>
                                    <div class="form-group">
                                        <label>Téléphone</label>
                                        <input v-model="form.telephone" type="tel" placeholder="06 00 00 00 00" id="inp-telephone" />
                                    </div>
                                    <div class="form-group md:col-span-2">
                                        <label>Nom de votre entreprise</label>
                                        <input v-model="form.entreprise" type="text" placeholder="CVC Services" id="inp-entreprise" />
                                    </div>
                                    <div class="form-group md:col-span-2">
                                        <label>Nombre de techniciens</label>
                                        <select v-model="form.nombreTechniciens" id="inp-nombreTechniciens">
                                            <option>Indépendant (1)</option>
                                            <option>2 à 5 techniciens</option>
                                            <option>6 à 15 techniciens</option>
                                            <option>Plus de 15 techniciens</option>
                                        </select>
                                    </div>
                                    <div class="form-group md:col-span-2">
                                        <label>Comment pouvons-nous vous aider ?</label>
                                        <textarea v-model="form.message" rows="4" placeholder="Votre message..." id="inp-message"></textarea>
                                    </div>
                                    <div class="md:col-span-2 flex justify-center mt-4">
                                        <div ref="turnstileContainer"></div>
                                    </div>
                                    <div class="md:col-span-2">
                                        <button :disabled="loadingSendForm" type="submit" class="btn-submit-contact">
                                            <span v-if="loadingSendForm">Envoi en cours...</span>
                                            <span v-if="!loadingSendForm">
                                                Envoyer ma demande <i class="fa-solid fa-paper-plane ml-2"></i>
                                            </span>
                                        </button>
                                        <p class="text-xs text-gray-400 mt-4 text-center italic">
                                            En envoyant ce formulaire, vous acceptez notre politique de confidentialité.
                                        </p>
                                    </div>
                                </form>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </section>
            
            <section class="py-24 bg-gray-50">
                <div class="max-w-4xl mx-auto px-4 text-center">
                    <h2 class="text-3xl font-bold mb-12">Questions fréquentes</h2>

                    <div class="space-y-6 text-left">

                        <div class="faq-item">
                            <h4 class="font-bold">Combien de temps prend la mise en service ?</h4>
                            <p class="text-gray-600">
                                Selon la taille de votre structure et le volume de données à reprendre, la mise en service prend généralement entre 24h et 72h.
                                L’objectif est une prise en main rapide, sans bloquer votre activité.
                            </p>
                        </div>

                        <div class="faq-item">
                            <h4 class="font-bold">Y a-t-il un engagement de durée ?</h4>
                            <p class="text-gray-600">
                                Non. Les abonnements Termoflow sont sans engagement de durée.
                                Vous restez libre à tout moment.
                            </p>
                        </div>

                        <div class="faq-item">
                            <h4 class="font-bold">Les SMS sont-ils inclus ?</h4>
                            <p class="text-gray-600">
                                Non. Les abonnements Termoflow ne comprennent pas les coûts de SMS.
                                Ceux-ci sont facturés en supplément selon la consommation réelle.
                            </p>
                        </div>

                        <div class="faq-item">
                            <h4 class="font-bold">Termoflow remplace-t-il mon logiciel de facturation ?</h4>
                            <p class="text-gray-600">
                                Non. Termoflow se concentre sur l’opérationnel, le terrain et la conformité.
                                Il se connecte à votre logiciel de facturation existant afin d’éviter toute double saisie.
                            </p>
                        </div>

                        <div class="faq-item">
                            <h4 class="font-bold">Est-ce que l’application fonctionne sans connexion internet ?</h4>
                            <p class="text-gray-600">
                                Oui. L’application mobile fonctionne hors connexion.
                                Les données sont synchronisées automatiquement dès que le réseau est disponible.
                            </p>
                        </div>

                        <div class="faq-item">
                            <h4 class="font-bold">Les CERFA générés sont-ils conformes à la réglementation ?</h4>
                            <p class="text-gray-600">
                                Oui. Les CERFA sont générés à partir des données terrain, liés aux fluides, aux bouteilles,
                                aux détecteurs de fuite et aux adresses de recyclage, assurant une traçabilité complète et conforme.
                            </p>
                        </div>

                        <div class="faq-item">
                            <h4 class="font-bold">Puis-je gérer plusieurs techniciens ?</h4>
                            <p class="text-gray-600">
                                Oui. L’offre Entreprise est conçue pour le multi-technicien avec planification,
                                suivi individuel, statistiques et pilotage avancé.
                            </p>
                        </div>

                        <div class="faq-item">
                            <h4 class="font-bold">Mes données sont-elles sécurisées ?</h4>
                            <p class="text-gray-600">
                                Oui. Les flux de données sont chiffrés et contrôlés.
                                L’accès aux informations est strictement limité selon les rôles et les droits utilisateurs.
                            </p>
                        </div>

                        <div class="faq-item">
                            <h4 class="font-bold">Puis-je exporter mes données à tout moment ?</h4>
                            <p class="text-gray-600">
                                Oui. Vous pouvez exporter vos interventions, stocks, bouteilles de gaz et données clés
                                avec des filtres précis, à tout moment.
                            </p>
                        </div>

                        <div class="faq-item">
                            <h4 class="font-bold">Termoflow est-il adapté aux indépendants ?</h4>
                            <p class="text-gray-600">
                                Oui. L’offre Indépendant a été pensée pour offrir toutes les fonctionnalités métier essentielles,
                                sans complexité inutile.
                            </p>
                        </div>

                        <div class="faq-item">
                            <h4 class="font-bold">Un accompagnement est-il prévu au démarrage ?</h4>
                            <p class="text-gray-600">
                                Oui. Nous accompagnons chaque client lors de la mise en place afin de garantir
                                une prise en main efficace et rapide.
                            </p>
                        </div>

                        <div class="faq-item">
                            <h4 class="font-bold">Puis-je bénéficier de l'offre entreprise en tant qu'indépendant ?</h4>
                            <p class="text-gray-600">
                                Oui. L’offre Entreprise est accessible à tous, y compris aux indépendants qui souhaitent bénéficier de fonctionnalités avancées ou d’un accompagnement renforcé.
                            </p>
                        </div>

                    </div>
                </div>
            </section>

        </main>
        
        <landing-footer />
    </div>
</template>

<script>
import LandingHeader from './LandingHeader.vue'
import LandingFooter from './LandingFooter.vue'

export default {
    name: 'LandingContact',
    components: {
        LandingHeader,
        LandingFooter
    },
    data() {
        return {
            form: {
                prenom: '',
                nom: '',
                email: '',
                telephone: '',
                entreprise: '',
                nombreTechniciens: '',
                message: ''
            },
            turnstileToken: null,
            turnstileWidgetId: null,
            loading: false,
            loadingSendForm: false
        }
    },
    mounted() {
        this.initTurnstile()
    },
    methods: {

        initTurnstile() {
            const waitForTurnstile = () => {
                if (!window.turnstile) {
                    setTimeout(waitForTurnstile, 300)
                    return
                }

                this.turnstileWidgetId = window.turnstile.render(
                    this.$refs.turnstileContainer,
                    {
                        sitekey: '0x4AAAAAACam_De7pAY2SMim',
                        theme: 'light',
                        callback: (token) => {
                            this.turnstileToken = token
                        },
                        'expired-callback': () => {
                            this.turnstileToken = null
                        },
                        'error-callback': () => {
                            this.turnstileToken = null
                        }
                    }
                )
            }

            waitForTurnstile()
        },

        async handleSubmit() {

            const validation = this.$inpError([
                'inp-prenom:required|min=2',
                'inp-nom:required|min=2',
                'inp-email:required|email',
                'inp-telephone:required|tel',
                'inp-entreprise:min=2',
                'inp-nombreTechniciens:required',
                'inp-message:required|min=5'
            ])

            if (!validation) {
                this.$toast.error('Formulaire invalide')
                return
            }

            if (!this.turnstileToken) {
                this.$toast.error('Veuillez valider le captcha')
                return
            }

            this.loading = true

            try {

                const payload = {
                    ...this.form,
                    turnstile_token: this.turnstileToken
                }
                this.loadingSendForm = true
                const response = await this.$request.post('/send-contact', payload)
                this.loadingSendForm = false

                if (response == 1) {

                    this.$toast.success('Votre demande a été envoyée avec succès')

                    this.resetForm()

                } else {
                    this.$toast.error('Une erreur est survenue.')
                }

            } catch (e) {
                this.$toast.error('Erreur serveur.')
            }

            this.loading = false
            this.loadingSendForm = false
        },

        resetForm() {
            this.form = {
                prenom: '',
                nom: '',
                email: '',
                telephone: '',
                entreprise: '',
                nombreTechniciens: '',
                message: ''
            }

            this.turnstileToken = null

            if (window.turnstile && this.turnstileWidgetId !== null) {
                window.turnstile.reset(this.turnstileWidgetId)
            }
        }
    }
}
</script>

<style scoped>
    .gradient-text {
        background: linear-gradient(to right, #f97316, #ef4444);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    
    .badge-contact {
        padding: 0.5rem 1.2rem;
        background: #fff7ed;
        color: #f97316;
        border-radius: 9999px;
        font-weight: 800;
        text-transform: uppercase;
        font-size: 0.75rem;
    }
    
    /* INFOS */
    .info-item { display: flex; align-items: center; gap: 1.5rem; }
    .info-icon {
        width: 3.5rem;
        height: 3.5rem;
        background: #f9fafb;
        color: #f97316;
        border-radius: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.25rem;
        flex-shrink: 0;
    }
    
    .demo-card-contact {
        background: linear-gradient(135deg, #f97316, #ef4444);
        padding: 2.5rem;
        border-radius: 2rem;
        box-shadow: 0 20px 25px -5px rgba(249, 115, 22, 0.2);
    }
    .btn-demo-white {
        width: 100%;
        background: white;
        color: #f97316;
        padding: 1rem;
        border-radius: 0.75rem;
        font-weight: 800;
        border: none;
        margin-top: 1rem;
    }
    
    /* FORMULAIRE */
    .form-container {
        background: white;
        padding: 3.5rem;
        border-radius: 2.5rem;
        border: 1px solid #f3f4f6;
    }
    .form-group { display: flex; flex-direction: column; gap: 0.5rem; }
    .form-group label { font-weight: 800; font-size: 0.85rem; color: #374151; }
    .form-group input, .form-group select, .form-group textarea {
        padding: 1rem;
        border-radius: 0.75rem;
        border: 1px solid #e5e7eb;
        background: #f9fafb;
        font-family: inherit;
        transition: all 0.2s;
    }
    .form-group input:focus { outline: none; border-color: #f97316; background: white; box-shadow: 0 0 0 4px rgba(249, 115, 22, 0.1); }
    
    .btn-submit-contact {
        width: 100%;
        background: #111827;
        color: white;
        padding: 1.2rem;
        border-radius: 0.75rem;
        font-weight: 800;
        font-size: 1.1rem;
        border: none;
        margin-top: 1rem;
        transition: background 0.2s;
    }
    .btn-submit-contact:hover { background: #000; }
    
    /* FAQ */
    .faq-item { background: white; padding: 2rem; border-radius: 1.25rem; border: 1px solid #e5e7eb; }
    
    @media (max-width: 768px) {
        .form-container { padding: 2rem 1.5rem; }
    }
</style>